import { render, staticRenderFns } from "./TabModeratorAccountClassroom.vue?vue&type=template&id=094b62b5&"
import script from "./TabModeratorAccountClassroom.vue?vue&type=script&lang=js&"
export * from "./TabModeratorAccountClassroom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports